<template>
    <div class="app-sidebar-wrapper" :style="{height: `calc( 100% - ${config.offsetTop}px)`}">
        <div class='i-sidebar' :style="{width:folded?'40px':config.width+'px'}">
            <div v-if="config.logo" class='logo  text-center'>
                <img :src="config.logo">
            </div>
            <a class="item" :href="'#'+item.path"
                :class="{active:item.path === $route.path, [item.className||'']: true}"
                :style="{borderColor:config.borderColor}" 
                :key="item.label" v-for='item in config.items' v-if="!item.hidden">
                <icon :name="item.icon" size="18"/> <span v-if='!folded'>&nbsp;&nbsp;{{item.label}}</span>
            </a>
        </div>
        <div class="i-wrapper"  :style="{width: folded?`calc( 100% - 40px )`:`calc( 100% - ${config.width}px )`}"> 
            <slot/>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                folded: localStorage.sidebarFolded === '1'
            }
        },
        mounted(){
            let self = this;
            _i.bus.$on('fold-sidebar',()=>{
                console.log(1);
                self.folded = !self.folded;
                localStorage.sidebarFolded = self.folded?'1':'0';
            });
        },
        props:{

            config:{
                type:Object,
                default(){
                    return {
                        items:[{
                            icon:'user',
                            label:'profile',
                            path:'alavey'
                        }]
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .i-sidebar{
        float: left;
        height: 100%;
        width:200px;
        border-right: 1px solid lightgrey;
        
    }
    .item:hover{
        background: whitesmoke;
        cursor: pointer;
    }
    .item{
        padding:14px 10px;
        border-bottom: 1px solid lightgrey;
        display: block;
        text-decoration: none;
        color: #555;
    }
    .item:last-child{
                
    }    

    .active{
        background: whitesmoke;
    }

    .i-wrapper{
        float:left;
        width:calc(100% - 202px);
        height: 100%;
        overflow-y: scroll;

        
    }

    .app-sidebar-wrapper{
        height:100%;
    }
    .logo{
        padding:12px 12px;
        background: linear-gradient(45deg,#e3e5e6,white);
        border-bottom: 1px solid lightgrey;

    }
    .logo img{
        max-width: 100%;
    }
</style>
